var scope_0 = require('/var/www/vhosts/whitehorsechoir.org/checkout/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/205f07a97e91fa3db684b4ba38cd3b7f.js').default;
var scope_1 = require('/var/www/vhosts/whitehorsechoir.org/checkout/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b20bb458f72da576c7dafc6759580650.js').default;
var scope_2 = require('/var/www/vhosts/whitehorsechoir.org/checkout/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    